"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableFormPageBlock = exports.FormPageBlock = exports.FormPageLayout = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("./FormPageLayout.css");
var Row_1 = require("../../components/Row");
var Stack_1 = require("../../components/Stack");
var classnames_1 = __importDefault(require("classnames"));
var Button_1 = require("../../components/Button");
var R = __importStar(require("../../utils/ramda"));
var widths = {
  narrow: 480,
  medium: 540,
  wide: 768
};
var FormPageLayout = function (_a) {
  var children = _a.children,
    className = _a.className,
    _b = _a.width,
    width = _b === void 0 ? "narrow" : _b,
    _c = _a.gap,
    gap = _c === void 0 ? false : _c,
    _d = _a.legacyStyles,
    legacyStyles = _d === void 0 ? false : _d,
    _e = _a.verticalPad,
    verticalPad = _e === void 0 ? false : _e,
    _f = _a.gapSize,
    gapSize = _f === void 0 ? "large" : _f,
    restProps = __rest(_a, ["children", "className", "width", "gap", "legacyStyles", "verticalPad", "gapSize"]);
  var cn = (0, classnames_1.default)("vsx-form-page-content", gap && "child-gap", legacyStyles && "vsx-styled-form", className);
  return (0, jsx_runtime_1.jsx)(Row_1.Row, __assign({
    className: (0, classnames_1.default)("vsx-form-page-layout", verticalPad && "vsx-form-page-layout-padded"),
    justify: "center",
    childBasis: typeof width === "string" ? widths[width] : "".concat(width, "px"),
    childShrink: true,
    role: "form"
  }, {
    children: (0, jsx_runtime_1.jsx)(Stack_1.Stack, __assign({
      gap: gap ? gapSize : "none",
      className: cn
    }, restProps, {
      children: children
    }))
  }));
};
exports.FormPageLayout = FormPageLayout;
var FormPageBlock = function (_a) {
  var title = _a.title,
    className = _a.className,
    children = _a.children,
    _b = _a.padding,
    padding = _b === void 0 ? "2xl" : _b,
    buttons = _a.buttons,
    titleRowProps = _a.titleRowProps,
    restProps = __rest(_a, ["title", "className", "children", "padding", "buttons", "titleRowProps"]);
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    className: (0, classnames_1.default)("vsx-form-page-block", className),
    gap: "larger",
    padding: padding
  }, restProps, {
    role: "form"
  }, {
    children: [(title || buttons) && (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      gap: "large",
      justify: "space-between",
      align: "center"
    }, titleRowProps, {
      children: [title ? (0, jsx_runtime_1.jsx)("div", __assign({
        className: "vsx-form-page-block-title"
      }, {
        children: title
      })) : (0, jsx_runtime_1.jsx)("span", {}), buttons ? (0, jsx_runtime_1.jsx)("div", __assign({
        className: "vsx-form-page-block-buttons"
      }, {
        children: buttons
      })) : (0, jsx_runtime_1.jsx)("span", {})]
    })), children && (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-form-page-block-children"
    }, {
      children: children
    }))]
  }));
};
exports.FormPageBlock = FormPageBlock;
var ExpandableFormPageBlock = function (_a) {
  var title = _a.title,
    className = _a.className,
    children = _a.children,
    expanded = _a.expanded,
    expandButtonText = _a.expandButtonText,
    saveButtonText = _a.saveButtonText,
    cancelButtonText = _a.cancelButtonText,
    _b = _a.collapsedContent,
    collapsedContent = _b === void 0 ? null : _b,
    _c = _a.collapseOnSave,
    collapseOnSave = _c === void 0 ? true : _c,
    setExpanded = _a.setExpanded,
    onSave = _a.onSave,
    _d = _a.onCancel,
    onCancel = _d === void 0 ? R.N : _d,
    _e = _a.padding,
    padding = _e === void 0 ? "2xl" : _e,
    restProps = __rest(_a, ["title", "className", "children", "expanded", "expandButtonText", "saveButtonText", "cancelButtonText", "collapsedContent", "collapseOnSave", "setExpanded", "onSave", "onCancel", "padding"]);
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    className: (0, classnames_1.default)("vsx-form-page-block", "vsx-expandable-form-page-block", className),
    gap: "larger",
    padding: padding
  }, restProps, {
    children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      justify: "space-between",
      align: "center"
    }, {
      children: [(0, jsx_runtime_1.jsx)("div", __assign({
        className: "vsx-form-page-block-title"
      }, {
        children: title
      })), expanded ? (0, jsx_runtime_1.jsx)("div", __assign({
        className: "vsx-form-page-button-stub"
      }, {
        children: (0, jsx_runtime_1.jsx)(Button_1.Button, {})
      })) : (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
        type: "primary",
        onClick: function () {
          return setExpanded(true);
        }
      }, {
        children: expandButtonText
      }))]
    })), expanded && (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-form-page-block-children"
    }, {
      children: children
    })), !expanded && collapsedContent !== null && (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-form-page-block-children"
    }, {
      children: collapsedContent
    })), expanded && (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      justify: "end",
      gap: "small"
    }, {
      children: [(0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
        type: "tertiary",
        onClick: function () {
          onCancel();
          setExpanded(false);
        }
      }, {
        children: cancelButtonText
      })), (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
        type: "primary",
        onClick: function () {
          onSave();
          collapseOnSave && setExpanded(false);
        }
      }, {
        children: saveButtonText
      }))]
    }))]
  }));
};
exports.ExpandableFormPageBlock = ExpandableFormPageBlock;